import Web3 from 'web3';

export default function get_web3_provider(rpc_url) {
  let web3;
  if (window.ethereum) {
    web3 = new Web3(window.ethereum);
    console.log("Using MetaMask provider");
  } else if (typeof rpc_url !== 'undefined' && rpc_url !== '') {
    web3 = new Web3(new Web3.providers.HttpProvider(rpc_url));
    console.log("Using provider: " + rpc_url)
  }
  return web3;
}
